import React from 'react';
import PropTypes from 'prop-types';

import styles from './Header.scss';

const Header = ({
  children,
  buttonContainer,
  noMargin
}) => (
  <div
    className={`${styles.Header}
    ${!buttonContainer ? styles.text : styles.buttons}
    ${noMargin ? styles['no-margin'] : ''}`}
  >
    {buttonContainer ?
      <div className={styles['button-container']}>
        {React.Children.map(children, child => React.cloneElement(child, { top: true }))}
      </div>
    :
      children
    }
  </div>
);

Header.defaultProps = {
  buttonContainer: false,
  noMargin: false
};

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]).isRequired,
  buttonContainer: PropTypes.bool,
  noMargin: PropTypes.bool
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js